var _excluded = ["anchorOrigin"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import uuidv4 from 'uuid/v4';
import { ToastContainer } from "./toastContainer";
import { ToastItem } from "./toastItem";
import { ToastContext } from "./ToastContext";
export var ToastProvider = function ToastProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      toasts = _React$useState2[0],
      setToasts = _React$useState2[1];

  var showToast = React.useCallback(function (options) {
    var _options$anchorOrigin = options.anchorOrigin,
        anchorOrigin = _options$anchorOrigin === void 0 ? {
      horizontal: 'right',
      vertical: 'bottom'
    } : _options$anchorOrigin,
        rest = _objectWithoutProperties(options, _excluded);

    var id = uuidv4();

    var toast = _objectSpread(_objectSpread({
      id: id
    }, rest), {}, {
      open: true,
      anchorOrigin: anchorOrigin
    });

    setToasts(function (toasts) {
      return [].concat(_toConsumableArray(toasts), [toast]);
    });
    return {
      id: id
    };
  }, []);
  var closeToast = React.useCallback(function (id) {
    setToasts(function (toasts) {
      var _toastToBeRemoved$onC;

      var toastToBeRemoved = toasts.find(function (toast) {
        return toast.id === id;
      });

      if (!toastToBeRemoved) {
        return toasts;
      }

      toastToBeRemoved === null || toastToBeRemoved === void 0 ? void 0 : (_toastToBeRemoved$onC = toastToBeRemoved.onClose) === null || _toastToBeRemoved$onC === void 0 ? void 0 : _toastToBeRemoved$onC.call(toastToBeRemoved);
      return toasts.filter(function (toast) {
        return toast.id !== id;
      });
    });
  }, []);
  var closeAllToasts = React.useCallback(function () {
    setToasts(function (toasts) {
      toasts.forEach(function (toast) {
        return closeToast(toast.id);
      });
      return [];
    });
  }, [closeToast]);

  var extractCategoryKey = function extractCategoryKey(anchorOrigin) {
    var categoryKey = "".concat(anchorOrigin.horizontal, "_").concat(anchorOrigin.vertical);
    return categoryKey.toLowerCase();
  };

  var toastPositionMapping = React.useMemo(function () {
    return toasts.reduce(function (acc, toast) {
      var anchorOrigin = toast.anchorOrigin;
      var categoryKey = extractCategoryKey(anchorOrigin);
      var existingToastsOfCategory = acc[categoryKey] || [];
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, categoryKey, [].concat(_toConsumableArray(existingToastsOfCategory), [toast])));
    }, {});
  }, [toasts]);
  return /*#__PURE__*/React.createElement(ToastContext.Provider, {
    value: {
      closeToast: closeToast,
      showToast: showToast,
      closeAllToasts: closeAllToasts
    }
  }, children, Object.keys(toastPositionMapping).map(function (categoryKey) {
    var toasts = toastPositionMapping[categoryKey];

    var _toasts = _slicedToArray(toasts, 1),
        _toasts$ = _toasts[0],
        anchorOrigin = _toasts$.anchorOrigin,
        id = _toasts$.id;

    return /*#__PURE__*/React.createElement(ToastContainer, {
      key: id,
      anchorOrigin: anchorOrigin
    }, toasts.map(function (toast) {
      return /*#__PURE__*/React.createElement(ToastItem, _extends({
        key: toast.id
      }, toast, {
        onClose: function onClose() {
          return closeToast(toast);
        }
      }));
    }));
  }));
};